import { Crosshair } from 'lucide-react'

/**
 * MITRE ATT&CK rendering, shared by the findings list and the Active Directory section.
 *
 * Extracted from AnalyticsReportDialog when the AD section needed the same badge: the section
 * is rendered BY the dialog, so importing the badge back out of it would have been circular.
 */

export const MITRE_TACTICS: Record<string, string> = {
    T1486: 'Impact', T1490: 'Impact', T1561: 'Impact',
    T1542: 'Persistence / Defense Evasion', T1070: 'Defense Evasion', T1562: 'Defense Evasion', T1112: 'Defense Evasion',
    T1136: 'Persistence', T1543: 'Persistence', T1053: 'Execution / Persistence',
    T1078: 'Privilege Escalation', T1110: 'Credential Access', T1021: 'Lateral Movement',
    T1059: 'Execution', T1071: 'Command and Control', T1566: 'Initial Access',
    // Active Directory. The ad_analysis engine reports these, and without them every AD
    // finding would render with a technique id and no tactic beside it.
    T1003: 'Credential Access', T1552: 'Credential Access', T1558: 'Credential Access',
    T1649: 'Credential Access', T1550: 'Lateral Movement', T1207: 'Defense Evasion',
    T1484: 'Privilege Escalation / Defense Evasion', T1098: 'Persistence',
    T1134: 'Privilege Escalation', T1068: 'Privilege Escalation', T1210: 'Lateral Movement',
    T1187: 'Credential Access', T1555: 'Credential Access',
}

export function tacticForTechnique(id?: string | null): string | null {
    if (!id) return null
    return MITRE_TACTICS[id] || MITRE_TACTICS[id.split('.')[0]] || null
}

export function mitreUrl(id: string): string {
    return `https://attack.mitre.org/techniques/${id.replace('.', '/')}/`
}

export function MitreBadge({ id, name, compact = false }: { id?: string | null; name?: string | null; compact?: boolean }) {
    if (!id) return null
    return (
        <a
            href={mitreUrl(id)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            title={name || id}
            className="inline-flex items-center gap-1 rounded px-2 py-0.5 text-xs font-medium bg-purple-100 text-purple-700 hover:bg-purple-200 dark:bg-purple-500/15 dark:text-purple-300 dark:hover:bg-purple-500/25 transition-colors"
        >
            <Crosshair className="h-3 w-3 flex-shrink-0" />
            <span className="tabular-nums">{id}</span>
            {!compact && name && <span className="hidden sm:inline truncate">&middot; {name}</span>}
        </a>
    )
}
